import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c66e156"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Loading... ")

import i18n from '@/locale/i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'X1DatatablePaginatorend',
  setup(__props) {

const t = i18n.global.t;


return (_ctx: any,_cache: any) => {
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createBlock(_component_DataTable, _mergeProps({
    rowsPerPageOptions: [10, 30, 50],
    paginator: true,
    rows: 10,
    paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
    currentPageReportTemplate: "{first} - {last} / {totalRecords}"
  }, _ctx.$attrs), {
    empty: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)("REGISTRATION.NO_GUEST")), 1)
    ]),
    loading: _withCtx(() => [
      _hoisted_1
    ]),
    expansion: _withCtx((slotProps) => [
      _renderSlot(_ctx.$slots, "expansion", {
        data: slotProps.data
      })
    ]),
    paginatorend: _withCtx((slotProps) => [
      _renderSlot(_ctx.$slots, "paginatorend", { slotProps: slotProps })
    ]),
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 16))
}
}

})